import Vue from 'vue'

import { HalfCircleSpinner } from 'epic-spinners'

export default Vue.extend({
  name: 'Loading',

  props: {
    loading: {
      type: Boolean as Prop<boolean>,
      default: false
    },
    bgColor: {
      type: String as Prop<string>,
      default: '#ffffff'
    },
    progressColor: {
      type: String as Prop<string>,
      default: '#70aba6'
    }
  },

  components: {
    spinner: HalfCircleSpinner
  },

  computed: {
    containerStyle (): any {
      return {
        'background-color': this.bgColor
      }
    }
  }
})
